export default __webpack_public_path__ + "static/media/ISRO_NRSC_Logo.49f9267f.png";